<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberDiary/activity')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validate" novalidate>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Exercise Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.excercise_name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Sub Category</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="subcategory" v-validate="'required'" v-model="addData.member_pt_diary_subcategory_id" class="mb-3">
                        <option value="">Please Select</option>
                        <option v-for="row in subcategories" :value="row.id" :key="row.id">{{ row.name }}</option>
                    </b-form-select>
                  </div>
                  <span class="error">{{ errors.first('category') }}</span>
                </b-col>
              </b-row>
              <!-- <b-row class="mb-20">
                <b-col sm="2">
                  <label>Sets</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.sets" name="sets" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('sets') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Reps</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.reps" name="reps" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('reps') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Time</label>
                </b-col>
                <b-col sm="10">
                  <div class="select-time">
                    <flat-pickr :config="timeConfig" v-model="addData.time" name="time" class="w-100"></flat-pickr>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Rest Time</label>
                </b-col>
                <b-col sm="10">
                  <div class="select-time">
                    <flat-pickr :config="timeConfig" v-model="addData.rest_time" name="rest_time" class="w-100"></flat-pickr>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Weight</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.weight" name="weight" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>One RM</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.one_rm" name="one_rm" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Dist</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.dist" name="dist" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Intensity</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.intensity" name="intensity" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Notes</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.notes" name="notes" type="text"></b-form-input>
                </b-col>
              </b-row> -->
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'memberDiaryActivityManage',
  data: function () {
    return {
      addData: {
        excercise_name: '',
        // sets: '',
        // reps: '',
        // time: '',
        // rest_time: '',
        // one_rm: '',
        // dist: '',
        // weight: '',
        // intensity: '',
        // notes: '',
        member_pt_diary_subcategory_id: null
      },
      subcategories: [],
      timeConfig: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        defaultDate: "00:00:00",
        static: true,
        time_24hr: true
      }
    }
  },
  methods: {
    async validate () {
        let isValid = await this.$validator.validateAll()
      
        if (!isValid) {
            this.$toast.success('please fill in required fields!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })

            return
        }

        try {
            let methods = (this.$route.params.id) ? 'put' : 'post'
            let id = this.$route.params.id || ''
            let response = await axios[methods]('crm/v1/member_pt_diary_activity/' + id , this.addData)
            this.$router.push('/memberDiary/activity')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
        } catch (error) {
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
        }
    },
    async getSubCategories () {
        axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
        let response = await axios.get('crm/v1/member_pt_diary_subcategory/')
        this.subcategories = response.data.data
        this.addData.member_pt_diary_subcategory_id = this.subcategories[0].id
    },
    openPage (event) {
      this.$router.push(event)
    },
    async getData () {
        if (!this.$route.params.id) return
        try {
            let response = await axios.get('crm/v1/member_pt_diary_activity/' + this.$route.params.id)
            delete response.data.data.member_pt_diary_subcategory
            this.addData = response.data.data
            console.log(this.addData)
        } catch (error) {
            this.$toast.error(error.message)
        }
    }
  },
  async mounted () {
      await this.getSubCategories()
      await this.getData()
  }
}
</script>

<style lang="scss" scoped>
</style>
